import { ShippingMethodPropertyMetadataCode } from '../enums/shipping-method-property-metadata-code';

export class ShippingMethodPropertyMetadata {
  public constructor(
    private readonly data: {
      code: ShippingMethodPropertyMetadataCode;
      value: string;
    },
  ) {}

  public get code(): ShippingMethodPropertyMetadataCode {
    return this.data.code;
  }

  public get value(): string {
    return this.data.value;
  }
}
